module.exports = __webpack_public_path__ + "static/client5-bbd54851d571423496b9b610bbac72f0.svg";